import * as t from "io-ts";
import {LatLngCodec} from "./lat-lng";
import {RouteResultCodec} from "./route-result";

export const OriginManyRouteResultItemCodec = t.intersection([
  t.type({
    index: t.number,
    destination: LatLngCodec,
  }),
  t.partial({
    route: RouteResultCodec,
    error: t.string,
  }),
]);

export type OriginManyRouteResultItem = t.TypeOf<typeof OriginManyRouteResultItemCodec>;

export const OriginManyRouteResultCodec = t.intersection([
  t.type({
    origin: LatLngCodec,
    status: t.string,
    total: t.number,
    succeeded: t.number,
    failed: t.number,
    results: t.array(OriginManyRouteResultItemCodec),
  }),
  t.partial({}),
]);

export type OriginManyRouteResult = t.TypeOf<typeof OriginManyRouteResultCodec>;
